(function () {
  const config = window.BYP_CONFIG || window.BYS_CONFIG || {};
  const state = {
    programs: [],
    programId: "",
    teamId: ""
  };

  const demoPrograms = [
    {
      id: "sample-program",
      name: "Sample Team Program",
      teams: [
        {
          id: "sample-team",
          name: "Example U13 Team",
          sport: "Hockey",
          deadline: "2026-09-15T20:00:00-04:00",
          items: []
        }
      ]
    }
  ];

  const selectors = {
    message: document.getElementById("bys-message"),
    program: document.getElementById("bys-program"),
    team: document.getElementById("bys-team"),
    name: document.getElementById("bys-name"),
    player: document.getElementById("bys-player"),
    items: document.getElementById("bys-items"),
    summary: document.getElementById("bys-team-summary"),
    heroDeadline: document.getElementById("bys-hero-deadline")
  };

  function showMessage(text, type) {
    if (!selectors.message) return;
    selectors.message.textContent = text || "";
    selectors.message.className = text
      ? `bys-message ${type ? `is-${type}` : ""}`
      : "bys-message hidden";
  }

  function money(value) {
    const amount = Number(value || 0);
    if (!Number.isFinite(amount) || amount <= 0) return "";
    return new Intl.NumberFormat("en-CA", {
      style: "currency",
      currency: "CAD"
    }).format(amount);
  }

  function formatDeadline(value) {
    if (!value) return "Deadline coming soon";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return new Intl.DateTimeFormat("en-CA", {
      weekday: "short",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      timeZoneName: "short"
    }).format(date);
  }

  function isPastDeadline(value) {
    if (!value) return false;
    const date = new Date(value);
    return !Number.isNaN(date.getTime()) && Date.now() > date.getTime();
  }

  function normalizePrograms(payload) {
    const rawPrograms = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.programs)
        ? payload.programs
        : Array.isArray(payload?.teams)
          ? [{ id: "teams", name: "Team Ordering", teams: payload.teams }]
          : [];

    return rawPrograms.map((program, programIndex) => {
      const teams = Array.isArray(program.teams) ? program.teams : [];
      return {
        id: String(program.id || program.programId || `program-${programIndex}`),
        name: String(program.name || program.programName || "Team Ordering"),
        teams: teams.map((team, teamIndex) => ({
          id: String(team.id || team.teamId || `team-${teamIndex}`),
          name: String(team.name || team.teamName || "Team"),
          sport: String(team.sport || ""),
          deadline: team.deadline || team.orderDeadline || "",
          items: Array.isArray(team.items) ? team.items : []
        }))
      };
    }).filter((program) => program.teams.length);
  }

  function currentProgram() {
    return state.programs.find((program) => program.id === state.programId) || null;
  }

  function currentTeam() {
    const program = currentProgram();
    if (!program) return null;
    return program.teams.find((team) => team.id === state.teamId) || null;
  }

  function option(value, label) {
    const el = document.createElement("option");
    el.value = value;
    el.textContent = label;
    return el;
  }

  function renderSelectors() {
    selectors.program.replaceChildren();
    selectors.team.replaceChildren();

    state.programs.forEach((program) => {
      selectors.program.appendChild(option(program.id, program.name));
    });

    if (!state.programId && state.programs[0]) {
      state.programId = state.programs[0].id;
    }

    const program = currentProgram();
    if (!program) return;

    program.teams.forEach((team) => {
      selectors.team.appendChild(option(team.id, team.name));
    });

    if (!state.teamId && program.teams[0]) {
      state.teamId = program.teams[0].id;
    }

    selectors.program.value = state.programId;
    selectors.team.value = state.teamId;
  }

  function buildProperties(team, item) {
    return {
      Name: selectors.name.value.trim(),
      Team: team.name,
      "Affiliated Player": selectors.player.value.trim(),
      Deadline: formatDeadline(team.deadline),
      _BYSMode: "sport",
      _BYSProgramId: state.programId,
      _BYSTeamId: team.id,
      _BYSDeadline: team.deadline || "",
      _BYSItemId: item.id || item.itemId || ""
    };
  }

  async function addToCart(item) {
    const team = currentTeam();
    const variantId = item.variantId || item.variant_id || item.id;

    showMessage("", "");

    if (!team || !variantId) {
      showMessage("This item needs a Shopify variant ID before it can be ordered.", "error");
      return;
    }

    if (!selectors.name.value.trim() || !selectors.player.value.trim()) {
      showMessage("Add your name and affiliated player before adding an item.", "error");
      return;
    }

    if (isPastDeadline(team.deadline)) {
      showMessage("This team's ordering deadline has passed.", "error");
      return;
    }

    const response = await fetch(config.cartAddUrl || "/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: Number(item.quantity || 1),
          properties: buildProperties(team, item)
        }]
      })
    });

    if (!response.ok) {
      throw new Error("Cart add failed");
    }

    showMessage("Added to cart.", "success");
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  }

  function renderItems() {
    const team = currentTeam();
    selectors.items.replaceChildren();

    if (!team) {
      selectors.summary.textContent = "Select a team to view the deadline and available items.";
      selectors.heroDeadline.textContent = "Select a team";
      return;
    }

    const deadlineLabel = formatDeadline(team.deadline);
    const closed = isPastDeadline(team.deadline);
    selectors.heroDeadline.textContent = deadlineLabel;
    selectors.summary.textContent = `${team.name}${team.sport ? ` (${team.sport})` : ""} order deadline: ${deadlineLabel}.`;

    if (!team.items.length) {
      const empty = document.createElement("div");
      empty.className = "bys-empty";
      empty.textContent = config.programsUrl
        ? "This team has no orderable items yet."
        : "Sport ordering is wired into the theme. Add an AWS programs URL with teams, deadlines, items, and Shopify variant IDs to turn ordering on.";
      selectors.items.appendChild(empty);
      return;
    }

    team.items.forEach((item) => {
      const row = document.createElement("article");
      row.className = "bys-item";

      const copy = document.createElement("div");
      const title = document.createElement("h3");
      const description = document.createElement("p");
      const price = document.createElement("span");

      title.textContent = item.title || item.name || "Team item";
      description.textContent = item.description || "";
      price.className = "bys-price";
      price.textContent = money(item.price);

      copy.append(title, description);
      if (price.textContent) copy.appendChild(price);

      const button = document.createElement("button");
      button.type = "button";
      button.className = "bys-button";
      button.textContent = closed ? "Closed" : "Add to cart";
      button.disabled = closed;
      button.addEventListener("click", async () => {
        button.disabled = true;
        button.textContent = "Adding...";
        try {
          await addToCart(item);
          button.textContent = "Added";
        } catch (err) {
          console.error(err);
          showMessage("Could not add that item to cart. Check the team item variant ID.", "error");
          button.disabled = false;
          button.textContent = "Add to cart";
        }
      });

      row.append(copy, button);
      selectors.items.appendChild(row);
    });
  }

  function bindEvents() {
    selectors.program.addEventListener("change", () => {
      state.programId = selectors.program.value;
      const program = currentProgram();
      state.teamId = program?.teams[0]?.id || "";
      renderSelectors();
      renderItems();
    });

    selectors.team.addEventListener("change", () => {
      state.teamId = selectors.team.value;
      renderItems();
    });
  }

  async function loadPrograms() {
    if (!config.programsUrl) {
      showMessage("Boost Your Program is ready for the AWS programs feed.", "");
      return demoPrograms;
    }

    const response = await fetch(config.programsUrl, {
      headers: { Accept: "application/json" }
    });

    if (!response.ok) {
      throw new Error("Programs feed failed");
    }

    const payload = await response.json();
    const programs = normalizePrograms(payload);
    if (!programs.length) throw new Error("No programs found");
    return programs;
  }

  async function init() {
    if (!selectors.program || !selectors.team || !selectors.items) return;

    bindEvents();

    try {
      state.programs = await loadPrograms();
      renderSelectors();
      renderItems();
    } catch (err) {
      console.error(err);
      state.programs = demoPrograms;
      showMessage("Could not load Boost Your Program programs yet.", "error");
      renderSelectors();
      renderItems();
    }
  }

  init();
})();
